__turbopack_context__.v({
  "bottomSquare": "RedPriceTooltip-module-scss-module__WvvYpq__bottomSquare",
  "tooltip": "RedPriceTooltip-module-scss-module__WvvYpq__tooltip",
  "tooltipBox": "RedPriceTooltip-module-scss-module__WvvYpq__tooltipBox",
  "tooltipContent": "RedPriceTooltip-module-scss-module__WvvYpq__tooltipContent",
  "topSquare": "RedPriceTooltip-module-scss-module__WvvYpq__topSquare",
  "wrapper": "RedPriceTooltip-module-scss-module__WvvYpq__wrapper",
});
